(function () {
  'use strict';

  var WINDOW_START = 6;
  var WINDOW_HOURS = 8;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function windowEnd() {
    var now = new Date();
    var start = new Date(now);
    start.setHours(WINDOW_START, 0, 0, 0);

    if (now < start) start.setDate(start.getDate() - 1);

    var elapsedHours = (now - start) / 3600000;
    var index = Math.floor(elapsedHours / WINDOW_HOURS);

    var end = new Date(start);
    end.setHours(end.getHours() + (index + 1) * WINDOW_HOURS);
    return end.getTime();
  }

  function init(banner) {
    if (banner.getAttribute('data-countdown') !== 'window') return;

    var hoursEl = banner.querySelector('#sale-hours');
    var minsEl = banner.querySelector('#sale-minutes');
    var secsEl = banner.querySelector('#sale-seconds');
    if (!hoursEl || !minsEl || !secsEl) return;

    function tick() {
      var diff = windowEnd() - Date.now();
      if (diff <= 0) diff = windowEnd() - Date.now();
      if (diff < 0) diff = 0;

      var total = Math.floor(diff / 1000);
      hoursEl.textContent = pad(Math.floor(total / 3600));
      minsEl.textContent = pad(Math.floor((total % 3600) / 60));
      secsEl.textContent = pad(total % 60);
    }

    tick();
    setInterval(tick, 1000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  function boot() {
    document.querySelectorAll('.sale-banner').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
